<template>
  <v-menu bottom left>
    <template v-slot:activator="vMenuScope">
      <v-btn icon v-bind="{ ...$attrs, ...vMenuScope.attrs }" v-on="{ ...$listeners, ...vMenuScope.on }">
        <v-icon>
          mdi-dots-horizontal
        </v-icon>
      </v-btn>
    </template>

    <template v-slot:default>
      <v-list class="pa-0">
        <v-list-item @click="() => $emit('click:update')">
          <v-list-item-content>
            <v-list-item-title>
              <v-icon left>
                mdi-table-cog
              </v-icon>

              Configurar tabela
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="() => $emit('click:edit-funds')">
          <v-list-item-content>
            <v-list-item-title>
              <v-icon left>
                mdi-table-edit
              </v-icon>

              Editar fundos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider />

        <v-list-item @click="() => $emit('click:delete')">
          <v-list-item-content>
            <v-list-item-title class="error--text">
              <v-icon left color="error">
                mdi-table-remove
              </v-icon>

              Deletar tabela
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-menu>
</template>

<script>
export default {
  name: 'BoardClassActionsMenu',

  inheritAttrs: false,
};
</script>
